import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode, EffectFade } from 'swiper';

function gallery() {

var swiper = new Swiper("[data-name='image-gallery']", {
    modules: [Navigation, Scrollbar, Autoplay, FreeMode, Pagination, EffectFade],
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: true
    // },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    pagination: {
        el: ".swiper-pagination",
        type: 'custom',
        renderCustom: function (swiper, current, total) {
            return current + ' of ' + (total); 
        }
      },
     });
}

    export default gallery;